/* ============================================================
   CELESTIAL VAULT — client-side form validation & sanitization
   Applies the site's validation policy to Dawn's contact +
   newsletter forms. Shopify re-validates server-side; this layer
   gives instant feedback and strips XSS vectors before submit.
   ============================================================ */
(function () {
  'use strict';

  /* ---- validators (mirror of the site validation schema) --- */
  var NAME_RE = /^[a-zA-Z\s\-'.]+$/;
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function validUKPhone(phone) {
    var d = phone.replace(/\D/g, '');
    if (d.indexOf('44') === 0) {
      return d.length === 12 && (d.indexOf('447') === 0 || d.indexOf('441') === 0 || d.indexOf('442') === 0);
    } else if (d.indexOf('0') === 0) {
      return d.length === 11 && (d.indexOf('07') === 0 || d.indexOf('01') === 0 || d.indexOf('02') === 0 || d.indexOf('03') === 0);
    } else if (d.indexOf('7') === 0) {
      return d.length === 10;
    }
    return false;
  }

  /* strip tags + angle brackets (XSS vectors) from free text */
  function sanitize(v) {
    return v.replace(/<[^>]*>/g, '').replace(/[<>]/g, '').trim();
  }

  var RULES = {
    name: function (v) {
      if (v.length < 2) return 'Name must be at least 2 characters';
      if (v.length > 100) return 'Name must be less than 100 characters';
      if (!NAME_RE.test(v)) return "Name can only contain letters, spaces, hyphens, apostrophes and dots";
      return '';
    },
    email: function (v) {
      if (!EMAIL_RE.test(v)) return 'Please enter a valid email address';
      if (v.length > 254) return 'Email must be less than 254 characters';
      return '';
    },
    phone: function (v) {
      if (!v) return ''; // optional
      if (v.length > 20) return 'Phone number must be less than 20 characters';
      if (!validUKPhone(v)) return 'Please enter a valid UK phone number (e.g. 07900 123456)';
      return '';
    },
    body: function (v) {
      if (v.length < 10) return 'Message must be at least 10 characters';
      if (v.length > 2000) return 'Message must be less than 2000 characters';
      return '';
    }
  };

  function ruleFor(input) {
    var n = (input.getAttribute('name') || '').toLowerCase();
    if (n.indexOf('[name]') > -1) return RULES.name;
    if (n.indexOf('[email]') > -1 || input.type === 'email') return RULES.email;
    if (n.indexOf('[phone]') > -1 || input.type === 'tel') return RULES.phone;
    if (n.indexOf('[body]') > -1 || input.tagName === 'TEXTAREA') return RULES.body;
    return null;
  }

  function errorEl(input) {
    var host = input.closest('.field') || input.parentElement;
    var el = host.querySelector('.cv-field-error');
    if (!el) {
      el = document.createElement('p');
      el.className = 'cv-field-error';
      el.setAttribute('role', 'alert');
      host.appendChild(el);
    }
    return el;
  }

  function validateInput(input) {
    var rule = ruleFor(input);
    if (!rule) return '';
    var v = input.value.trim();
    // An empty OPTIONAL field is always valid — rules only apply to
    // entered values (required-ness is enforced natively by the browser).
    if (!v && !input.required) {
      var elEmpty = errorEl(input);
      elEmpty.textContent = '';
      input.classList.remove('cv-field--invalid');
      input.setAttribute('aria-invalid', 'false');
      return '';
    }
    var msg = rule(v);
    var el = errorEl(input);
    el.textContent = msg;
    input.classList.toggle('cv-field--invalid', !!msg);
    input.setAttribute('aria-invalid', msg ? 'true' : 'false');
    return msg;
  }

  function enhanceForm(form) {
    if (form.dataset.cvForms === '1') return;
    form.dataset.cvForms = '1';

    var inputs = Array.prototype.filter.call(
      form.querySelectorAll('input[type="text"], input[type="email"], input[type="tel"], textarea'),
      ruleFor
    );
    if (!inputs.length) return;

    inputs.forEach(function (input) {
      input.addEventListener('blur', function () { validateInput(input); });
      input.addEventListener('input', function () {
        if (input.classList.contains('cv-field--invalid')) validateInput(input);
      });
    });

    form.addEventListener('submit', function (e) {
      var failed = false;
      inputs.forEach(function (input) {
        // sanitize free-text fields before submission
        if (input.type !== 'email') input.value = sanitize(input.value);
        if (validateInput(input)) failed = true;
      });
      if (failed) {
        e.preventDefault();
        var firstBad = form.querySelector('.cv-field--invalid');
        if (firstBad) firstBad.focus();
        return;
      }
      // lock submit to prevent double-send
      var btn = form.querySelector('button[type="submit"], input[type="submit"]');
      if (btn) {
        btn.disabled = true;
        setTimeout(function () { btn.disabled = false; }, 6000);
      }
    });
  }

  function init() {
    document.querySelectorAll('form[action*="/contact"], form.newsletter-form, form[id*="ContactForm"]').forEach(enhanceForm);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
